
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M14 5.99998H17V13.88L19 15.88V4.99998C19 4.44998 18.55 3.99998 18 3.99998H14C14 3.44998 13.55 2.99998 13 2.99998H6.11998L14 10.88V5.99998ZM21.17 20.88L12 11.71V13H9.99998V11H11.29L3.11998 2.82998C2.72998 2.43998 2.09998 2.43998 1.70998 2.82998C1.31998 3.21998 1.31998 3.84998 1.70998 4.23998L4.99998 7.53998V19H3.99998C3.44998 19 2.99998 19.45 2.99998 20C2.99998 20.55 3.44998 21 3.99998 21H13C13.55 21 14 20.55 14 20V16.54L19.75 22.29C20.14 22.68 20.77 22.68 21.16 22.29C21.56 21.9 21.56 21.27 21.17 20.88Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-no-meeting-room`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconNoMeetingRoom

    ```js
    <b-new-b-icon-no-meeting-room />
    ```
</docs>


